/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Container, Col, Row, Card } from 'react-bootstrap';
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Window from './window'
import Header from "./header"
import "prismjs/themes/prism-tomorrow.css"
import "./layout.css"
import SEO from "./seo.js"

const Layout = ({ children, icon }) => {
    const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
      <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <SEO title={data.site.siteMetadata.title}/>
      <Window icon={icon}>
          <div
              style={{
                  margin: `0 auto`,
                  maxWidth: 960,
                  padding: `0 1.0875rem 1.45rem`,
              }}
          >
              <main>{children}</main>
          </div>
      </Window>

      <footer className="cloud-sky" style={{
          paddingTop: '2rem',
          paddingBottom: '2rem',
      }}>
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.org">Gatsby</a>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
